<script>
export default {
	name: 'IconSvgBzip',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.4781 4.104C13.0134 4.10333 12.5678 3.92198 12.2392 3.5997C11.9107 3.27743 11.7259 2.84055 11.7254 2.3849V0H3.89355C3.28691 0 2.70511 0.236249 2.27615 0.656782C1.84719 1.07731 1.6062 1.64769 1.6062 2.24241V15.7602C1.6071 16.3543 1.84849 16.9238 2.27735 17.3436C2.70621 17.7635 3.28749 17.9993 3.89355 17.9992H13.2954C13.9015 17.9993 14.4827 17.7635 14.9116 17.3436C15.3405 16.9238 15.5818 16.3543 15.5827 15.7602V4.104H13.4781Z"
				:fill="color" />
			<path
				d="M15.5828 4.104H13.4782C13.0134 4.10333 12.5678 3.92198 12.2393 3.5997C11.9107 3.27743 11.7259 2.84055 11.7255 2.3849V0L15.5828 4.104Z"
				fill="#FFBC00" />
			<path
				d="M17.2411 14.2169H6.61266C5.85873 14.2169 5.24756 14.8161 5.24756 15.5552V18.6617C5.24756 19.4008 5.85873 20 6.61266 20H17.2411C17.995 20 18.6062 19.4008 18.6062 18.6617V15.5552C18.6062 14.8161 17.995 14.2169 17.2411 14.2169Z"
				fill="#FFBC00" />
			<path
				d="M11.6212 17.8723H12.7492V18.3614H10.9344V17.9006L12.0445 16.3415H10.9489V15.8557H12.7424V16.3165L11.6212 17.8723Z"
				fill="#F3F3F6" />
			<path d="M13.7467 15.8557V18.3614H13.1313V15.8557H13.7467Z" fill="#F3F3F6" />
			<path
				d="M14.7915 17.4823V18.3614H14.1736V15.8557H15.1715C15.4749 15.8557 15.707 15.929 15.8659 16.0774C15.9464 16.1547 16.0093 16.2478 16.0505 16.3506C16.0916 16.4535 16.1101 16.5637 16.1048 16.674C16.1075 16.8198 16.0705 16.9636 15.9977 17.0907C15.9235 17.2149 15.8135 17.315 15.6815 17.3782C15.5222 17.4516 15.3475 17.4873 15.1715 17.4823H14.7915ZM15.4783 16.674C15.4783 16.4546 15.3542 16.3435 15.106 16.3407H14.7915V16.9923H15.106C15.3542 16.9951 15.4783 16.889 15.4783 16.674Z"
				fill="#F3F3F6" />
			<path d="M8.38809 17.7556V18.3614H7.74805V17.7556H8.38809Z" fill="#F3F3F6" />
			<path
				d="M10.5263 17.2939C10.6142 17.4034 10.661 17.5402 10.6588 17.6806C10.6631 17.7747 10.6461 17.8685 10.609 17.9551C10.572 18.0417 10.5158 18.1188 10.4446 18.1806C10.3013 18.3006 10.0963 18.3614 9.82963 18.3614H8.66296V15.8556H9.80046C10.0555 15.8556 10.2527 15.9111 10.3921 16.0223C10.4618 16.0794 10.5171 16.1522 10.5534 16.2348C10.5898 16.3173 10.6062 16.4072 10.6013 16.4973C10.6066 16.6332 10.5641 16.7668 10.4813 16.8748C10.402 16.9749 10.2903 17.0444 10.1655 17.0714C10.3077 17.1021 10.4351 17.1806 10.5263 17.2939ZM9.26963 16.8831H9.6663C9.87686 16.8831 9.98214 16.7931 9.98214 16.6131C9.98214 16.4331 9.87463 16.3434 9.65963 16.3439H9.26963V16.8831ZM10.0388 17.5956C10.0407 17.5561 10.0338 17.5166 10.0185 17.4802C10.0032 17.4437 9.97998 17.4111 9.95046 17.3848C9.87902 17.33 9.79029 17.3028 9.70046 17.3081H9.2713V17.8714H9.7038C9.92713 17.8714 10.0388 17.7795 10.0388 17.5956Z"
				fill="#F3F3F6" />
			<path
				d="M8.5933 12.7095C8.30744 12.7091 8.03343 12.5975 7.83138 12.3993C7.62933 12.201 7.51573 11.9323 7.5155 11.6521V10.5946H9.67195V11.6521C9.67173 11.9324 9.55801 12.2013 9.35577 12.3996C9.15353 12.5978 8.87931 12.7093 8.5933 12.7095ZM8.06715 11.1354V11.6521C8.06715 11.7889 8.12256 11.9202 8.2212 12.0171C8.31985 12.114 8.45368 12.1685 8.5933 12.1687C8.733 12.1685 8.86691 12.114 8.9657 12.0171C9.06448 11.9203 9.12007 11.789 9.1203 11.6521V11.1354H8.06715Z"
				fill="#FFBC00" />
			<path d="M7.51438 10.5955H8.59558V9.5355H7.51438V10.5955Z" fill="#FFBC00" />
			<path d="M8.59324 9.53625H9.67444V8.4763H8.59324V9.53625Z" fill="#FFBC00" />
			<path d="M7.51438 8.47717H8.59558V7.41722H7.51438V8.47717Z" fill="#FFBC00" />
			<path d="M8.59324 7.41797H9.67444V6.35802H8.59324V7.41797Z" fill="#FFBC00" />
		</svg>

	</div>
</template>

<style scoped>

</style>